import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty, get } from 'lodash';
import { Form } from 'semantic-ui-react';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import { forgotPasswordAction } from '../../../actions';
import { formFields } from "./constant"
import Input from '../../../components/FormElements/Input';

import ModalConfirmation from '../../../components/ModalConfirmation';
import routes from '../../../routes';
import { handleFieldError, handleError } from '../../../utils/form-validation';
// import imgauth from '../../../assets/theme/img/illustrations/auth-login-illustration-dark.png';
import illustrationLight from "../../../assets/images/illustrations/auth-register-illustration-light.png";
import imgBg from '../../../assets/images/illustrations/bg-shape-image-light.png';
import infomoImg from '../../../assets/images/bekiLogo.png';
import { defaultPlatformConfig } from '../../../constants/configuration';

const AuthenticationCard = asyncRoute(() => import('../../../components/Card/AuthenticationCard'));
const TextField = asyncRoute(() => import('../../../components/elements/TextField'));
const Button = asyncRoute(() => import('../../../components/elements/Button'));
const AuthenticationBody = asyncRoute(() => import('../../../components/AuthenticationBody'));
const AlertPopUp = asyncRoute(() => import('../../../components/AlertPopUp'));

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {},
            touched: {},
            errors: {},
            submited: false,
            // formFieldsState: {
            //     username: '',
            // },
            isForgotSubmitDisabled: true,
            confirmationOpen: false,
            confirmationInfo: '',
            logoImage: ''
        };
        // this.handleFormFieldChange = this.handleFormFieldChange.bind(this);
        this.handleForgotSubmit = this.handleForgotSubmit.bind(this);
    }


    // handleFormFieldChange(event) {
    //     const formField = { ...this.state.formFieldsState };
    //     const { name, value } = event.target;
    //     formField[name] = value;
    //     this.setState({
    //         formFieldsState: formField,
    //     }, () => {
    //         const isForgotSubmitDisabled = this.checkForgotSubmitDisabled();
    //         this.setState({
    //             isForgotSubmitDisabled,
    //         });
    //     });
    // }

    componentWillMount() {
        const { platformConfiguration } = this.props;
        let logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        if (platformConfiguration && platformConfiguration['lable']['logo'] && platformConfiguration['lable']['logo'].length > 0) {
            if (platformConfiguration['lable']['logo'][0].hasOwnProperty('path')) {
                logoImageUrl = platformConfiguration['lable']['logo'][0]['path'];
            }
        }
        this.setState({ logoImage: logoImageUrl });
    }

    checkForgotSubmitDisabled() {
        const { form } = this.state;
        let { valid } = handleError(form, formFields);
        return (isEmpty(form.email) || !valid);
    }

    async handleForgotSubmit(e) {
        e.preventDefault();
        const { form } = this.state;
        const { forgotPasswordAction } = this.props;
        let { errors, valid } = handleError(form, formFields);
        if (valid) {
            const { responseCode: { status="",msg="" } } = await forgotPasswordAction(form.email)
            if (status.toLowerCase() == "success") {
                let successfullyMessage = { action: { confirmationMessage: msg, type: 'alert', iconColor: '#12b912', headingColor: '#12b912', textColor: 'black' } }
                this.setState({ confirmationOpen: false, form: {}, errors: {} }, () => {
                    this.toggleModal(successfullyMessage);
                })
                return;
            } else {
                const info = { action: { confirmationMessage: msg, type: 'error', iconColor: 'red', headingColor: 'red', textColor: 'red' } }
                this.toggleModal(info);
                return;
            }
        } else {
            this.setState({ errors: errors, submited: true });
        }
    }

    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation })
    }

    confirmationCallBack = (success, info) => {
        const { confirmationOpen } = this.state;
        const { history } = this.props;
        if (info.action.type === 'alert') {
            this.setState({ confirmationOpen: !confirmationOpen }, () => history.push(routes.preSignIn))
            return;
        }
        this.setState({ confirmationOpen: false });
    }

    handleChange = (e) => {
        let { form } = this.state;
        let { value, name } = e.target;
        form[name] = value;
        this.setState({ form }, () => {
            const isForgotSubmitDisabled = this.checkForgotSubmitDisabled();
            this.setState({
                isForgotSubmitDisabled,
            });
        });
    }

    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    }

    toggleToast = (info) => {
        const { confirmationOpen } = this.state;
        const { history } = this.props;
        if (info.action.type === 'alert') {
            this.setState({ confirmationOpen: !confirmationOpen }, () => history.push(routes.preSignIn))
            return;
        }
        this.setState({ confirmationOpen: false });
    }

    render() {
        const { isForgotSubmitDisabled, confirmationOpen, confirmationInfo, form, errors, submited, touched, logoImage} = this.state;

        return (
            <>
                {/* {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)} */}

                <AlertPopUp
                    callBackToast={this.toggleToast}
                    confirmationInfo={confirmationInfo}
                    showToast={confirmationOpen}
                    iconColor={
                        confirmationInfo && confirmationInfo.action && confirmationInfo.action.iconColor ? confirmationInfo.action.iconColor : ''
                    }
                    headingColor={
                        confirmationInfo && confirmationInfo.action && confirmationInfo.action.headingColor ? confirmationInfo.action.headingColor : ''
                    }
                >
                    <>
                        <p style={{ color: confirmationInfo && confirmationInfo.action && confirmationInfo.action.textColor ? confirmationInfo.action.textColor : 'black' }}>
                            {confirmationInfo && confirmationInfo.action && confirmationInfo.action.confirmationMessage ? confirmationInfo.action.confirmationMessage : ''}
                        </p>
                    </>
                </AlertPopUp>
                <AuthenticationBody>
                    <div class="d-none d-lg-flex col-lg-7 p-0">
                        <div class="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
                            <img
                                src={illustrationLight}
                                alt="auth-register-cover"
                                class="img-fluid my-5 auth-illustration"
                                data-app-light-img="illustrations/auth-register-illustration-light.png"
                                data-app-dark-img="illustrations/auth-register-illustration-dark.png"
                            />

                            <img
                                src={imgBg}
                                alt="auth-register-cover"
                                class="platform-bg"
                                data-app-light-img="illustrations/bg-shape-image-light.png"
                                data-app-dark-img="illustrations/bg-shape-image-dark.png"
                            />
                        </div>
                    </div>
                    <div class="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
                        <div class="w-px-400 mx-auto">
                            <div class="app-brand mb-4">
                                <a href="#" class="app-brand-link gap-2">
                                    <img style={{ width: '30%' }} src={logoImage} />
                                </a>
                            </div>
                            {/* <h3 class="mb-1 fw-bold">Welcome to Infomo! 👋</h3> */}
                            <p class="mb-4">Please enter your email to reset password</p>

                            <form id="formAuthentication" class="mb-3" onSubmit={this.handleForgotSubmit}>
                                <div class="mb-3">
                                    <Input
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.email.key]}
                                        setting={formFields[formFields.email.key]}
                                        error={errors[formFields.email.key]}
                                        submited={submited}
                                        touched={touched[formFields.email.key]}
                                    />
                                </div>

                                <button disabled={isForgotSubmitDisabled} class="btn btn-primary d-grid w-100">Submit</button>
                            </form>
                        </div>
                    </div >
                    {/* <AuthenticationCard> */}

                    {/* </AuthenticationCard> */}
                </AuthenticationBody>
            </>
        );
    }
}

export default connect(
    state => ({
        preSignInStatus: get(state, 'app.preSignInData.responeCode.status', ''),
        platformConfiguration: get(state, 'app.platformConfiguration', '')
    }),
    {
        forgotPasswordAction
    }
)(withRouter(ForgotPassword))
